{
  "room noun|room": "ルーム",
  "room noun|stage": "ステージ",
  "room noun|track": "トラック",
  "room noun|court": "コート",
  "room noun|field": "フィールド",
  "room noun|hall": "ホール",
  "room noun|camera": "カメラ",
  "Every {noun} shares one fundraiser": "すべての{noun}で1つの募金活動を共有しています",
  "Open the main event's fundraising": "メインイベントの募金を開く",
  "The donate button (and the stream overlay, if it's on) appear in {room} too, and donations count toward the same goal.": "「寄付する」ボタン（オンの場合は配信上の寄付トラッカーも）は{room}にも表示され、寄付は同じ目標額に加算されます。",
  "Choose an event to set up fundraising.": "募金を設定するイベントを選んでください。",
  "We added {name}. Check the details, then press Save to turn on donations.": "{name}を追加しました。詳細を確認してから「保存」を押すと、寄付の受付がオンになります。",
  "We couldn't find {organization} yet. Newly added organizations can take a few days to appear, so search again later.": "{organization}はまだ見つかりません。新しく追加された団体は表示されるまで数日かかることがあるため、あとでもう一度検索してください。",
  "Select {organization} from the search results below, then press Save.": "下の検索結果から{organization}を選択し、「保存」を押してください。",
  "choose an organization": "団体を選択してください",
  "Fundraiser saved.": "募金活動を保存しました。",
  "EIN unavailable": "EINなし",
  "Add": "追加",
  "Remove {name}": "{name}を削除",
  "Add {name}": "{name}を追加",
  "Bring people together for a cause. Choose one or more organizations to receive donations through Pledge.": "大切な目的のために、人々の力を集めましょう。Pledgeを通じて寄付を受け取る団体を1つ以上選んでください。",
  "Test fundraiser · Donations in this environment are for testing.": "テスト用の募金活動 · この環境での寄付はテスト用です。",
  "Loading fundraiser": "募金活動を読み込み中",
  "Organizations": "団体",
  "Search organizations by name or EIN": "名前またはEINで団体を検索",
  "Search by name or EIN": "名前またはEINで検索",
  "Clear search": "検索をクリア",
  "Check the EIN and address to make sure you have the right organization.": "EINと住所を確認して、正しい団体かどうか確かめてください。",
  "Finding your organization": "団体を検索しています",
  "Searching organizations": "団体を検索中",
  "No more matches. Try the organization’s full name or EIN.": "これ以上一致する団体はありません。団体の正式名称またはEINでお試しください。",
  "Donation options": "寄付の設定",
  "Show donations on the event page": "イベントページに寄付を表示",
  "Show the live donation tracker on your stream": "配信にリアルタイムの寄付トラッカーを表示",
  "Shows the amount raised, new donations and a Scan to donate QR code. Changes apply the next time you go live.": "集まった金額、新しい寄付、「スキャンして寄付」のQRコードを表示します。変更は次回のライブ配信から反映されます。",
  "Show donations in the guestbook": "ゲストブックに寄付を表示",
  "Confirmed donations appear in the guestbook or chat when messaging is on. Anonymous donors stay anonymous.": "メッセージ機能がオンの場合、確定した寄付はゲストブックまたはチャットに表示されます。匿名の寄付者は匿名のまま表示されます。",
  "Button and goal": "ボタンと目標額",
  "Button label": "ボタンのテキスト",
  "Donate": "寄付する",
  "Fundraising goal (USD)": "募金の目標額（USD）",
  "e.g. 5000": "例：5000",
  "Suggested donation (USD)": "寄付額の目安（USD）",
  "Share and manage": "共有と管理",
  "Donate link": "寄付用リンク",
  "Opens your event page with the donation form, even for people who haven't registered or bought a ticket. The QR code on your stream opens it too.": "寄付フォーム付きでイベントページが開きます。登録やチケットの購入をしていない人でも開けます。配信上のQRコードからも開きます。",
  "Copy donate link": "寄付用リンクをコピー",
  "Donate link copied": "寄付用リンクをコピーしました",
  "On Pledge": "Pledgeでの管理",
  "You're an organizer of this fundraiser on Pledge. Create a free Pledge account (or sign in) at pledge.to with your EventLive account's email to see donor details, customize the campaign page and add a text-to-donate keyword. Changes you save here update the title, organizations and goal on Pledge.": "あなたはPledgeでこの募金活動の主催者になっています。EventLiveアカウントのメールアドレスでpledge.toの無料Pledgeアカウントを作成（またはログイン）すると、寄付者の詳細の確認、キャンペーンページのカスタマイズ、SMS寄付用キーワードの追加ができます。ここで保存した変更は、Pledge上のタイトル、団体、目標額に反映されます。",
  "Turn off fundraising": "募金をオフにする",
  "Choose an organization to keep fundraising, or turn it off.": "募金を続けるには団体を選ぶか、募金をオフにしてください。",
  "Turn on fundraising": "募金をオンにする",
  "Creates your fundraiser on Pledge, with you as its organizer (your account email). After that, changes save automatically.": "あなた（アカウントのメールアドレス）を主催者として、Pledgeに募金活動を作成します。その後、変更は自動的に保存されます。",
  "Choose an organization first.": "先に団体を選んでください。",
  "Finish your fundraiser setup": "募金活動の設定を完了しましょう",
  "Set up your live fundraiser": "募金ライブ配信を設定",
  "Confirm {organization} and press Save to turn on donations for {event}.": "{organization}を確認し、「保存」を押して{event}の寄付受付をオンにしてください。",
  "Confirm the organization and press Save to turn on donations for {event}.": "団体を確認し、「保存」を押して{event}の寄付受付をオンにしてください。",
  "Schedule a live stream and collect donations for {organization} on your event page.": "ライブ配信の予定を設定して、イベントページで{organization}への寄付を集めましょう。",
  "Schedule a live stream and collect donations on your event page.": "ライブ配信の予定を設定して、イベントページで寄付を集めましょう。",
  "Review fundraiser": "募金活動を確認",
  "Create fundraiser event": "募金イベントを作成",
  "Dismiss fundraiser setup": "募金活動の設定を閉じる",
  "{name} Live Fundraiser": "{name}の募金ライブ配信",
  "Streaming is free for events you create before Jan 1, 2027 — thanks for fundraising with Pledge": "2027年1月1日より前に作成したイベントは無料で配信できます — Pledgeで募金活動をしていただき、ありがとうございます",
  "We'll unlock free streaming as soon as Pledge confirms your organization, usually within 24 hours": "Pledgeが団体を確認しだい、無料配信をアンロックします（通常は24時間以内）",
  "Anonymous": "匿名",
  "Made a donation": "寄付しました",
  "Donated {amount}": "{amount}を寄付しました",
  "You don't have access to fundraising for this event.": "このイベントの募金にアクセスする権限がありません。",
  "Fundraising isn't available yet. Please try again later.": "募金はまだご利用いただけません。しばらくしてからもう一度お試しください。",
  "Another fundraiser update is being saved. Please try again.": "募金活動の別の変更を保存中です。もう一度お試しください。",
  "Fundraising is temporarily unavailable. Please try again later.": "募金は一時的にご利用いただけません。しばらくしてからもう一度お試しください。",
  "Could not reach fundraising. Check your internet connection and try again.": "募金サービスに接続できませんでした。インターネット接続を確認して、もう一度お試しください。"
}
